import { Reducer, useReducer } from 'react'
import { TokenBalance } from '../../../../../graphql/generated/graphql'
import { DirectPayment, TransactionReceipt } from './DirectPayContext'

export enum DirectPayStep {
    CREATE,
    SUMMARY,
}

export interface DirectPayState {
    step: DirectPayStep
    receipt: TransactionReceipt | null
    selectedToken: TokenBalance | null
    directPayment: DirectPayment | null
}

export type DirectPayStateAction =
    | { type: 'reset' }
    | { type: 'set-token'; payload: TokenBalance | null }
    | { type: 'set-direct-payment'; payload: DirectPayment | null }
    | { type: 'set-summary'; payload: TransactionReceipt | null }

const initialState: DirectPayState = {
    step: DirectPayStep.CREATE,
    receipt: null,
    selectedToken: null,
    directPayment: null,
}

const reducer: Reducer<DirectPayState, DirectPayStateAction> = (state, action) => {
    switch (action.type) {
        case 'set-token': {
            return { ...state, selectedToken: action.payload }
        }
        case 'set-direct-payment': {
            return { ...state, directPayment: action.payload }
        }
        case 'set-summary': {
            return { ...state, receipt: action.payload, step: DirectPayStep.SUMMARY }
        }
        case 'reset': {
            return initialState
        }
        default:
            return initialState
    }
}

export const useDirectPayState = () => {
    const [state, dispatch] = useReducer(reducer, initialState)
    return {
        ...state,
        dispatch,
    }
}
